export const getItem = (key) => {
  const value = window.localStorage.getItem(key) || null;
  return value;
};
export const setItem = (key, value) => {
  window.localStorage.setItem(key, value);
};

export const removeItem = (key) => {
  window.localStorage.removeItem(key);
};

export const keys = {
  'MyTaskActionDate': 'event-planning-mobile-my-task-action-date',
  'MyTaskSearchMainData': 'event-planning-mobile-my-task-search-main-data',
  'MyTaskSearchDetailData': 'event-planning-mobile-my-task-search-detail-data',
  'MyApplicationSearchMainData': 'event-planning-mobile-my-application-search-main-data',
  'MyApplicationSearchDetailData': 'event-planning-mobile-my-application-search-detail-data',
  'MyLibrarySearchMainData': 'event-planning-mobile-my-library-search-main-data',
  'MyLibrarySearchDetailData': 'event-planning-mobile-my-library-search-detail-data',
}



// WEBPACK FOOTER //
// ./src/util/StorageService.js